import {
    getElement, navigateSmoothly,
    SELECTED_UNIVERSITY_STORAGE_KEY as UNIVERSITY_STORAGE_KEY,
    SELECTED_FACULTY_STORAGE_KEY as FACULTY_STORAGE_KEY,
    getSavedValue as getSaved, clearValue,
} from "./generics";
import { mountUniversityPicker } from "./universityPicker";

// Strona wyboru uczelni/wydziału (/inne/, patrz choose_university w views.py) - sam picker żyje
// w universityPicker.ts (współdzielony z kafelkami na stronie głównej, landing3.ts). Oba wybory
// są zapamiętywane - gdy oba są znane, strona w ogóle nie buduje UI i przenosi od razu na
// zapamiętaną listę (patrz init() niżej). Klucze/helpery współdzielone z landing3.ts - patrz
// SELECTED_*_STORAGE_KEY w generics.ts.

async function init(): Promise<void> {
    // Link "Zmień uczelnię" (patrz browse.html) prowadzi tu z ?zmien=1 - bez tego ta strona,
    // widząc już zapamiętany wybór, sama przeniosłaby od razu z powrotem na tę samą listę
    // wykładowców, zamiast pokazać picker (patrz redirect niżej).
    if (new URLSearchParams(window.location.search).has("zmien")) {
        clearValue(UNIVERSITY_STORAGE_KEY);
        clearValue(FACULTY_STORAGE_KEY);
    }

    const savedUniversitySlug = getSaved(UNIVERSITY_STORAGE_KEY);
    const savedFacultySlug = getSaved(FACULTY_STORAGE_KEY);

    // Oba wybory już znane - od razu przenosimy na listę, bez pokazywania/budowania UI
    // i bez zbędnego zapytania o listę uczelni.
    if (savedUniversitySlug && savedFacultySlug) {
        navigateSmoothly(`/${savedUniversitySlug}/${savedFacultySlug}/`);
        return;
    }

    mountUniversityPicker(getElement<HTMLDivElement>("landing-container"), savedUniversitySlug);
}

init();
